import {RevealAnimation} from "../../animations/RevealAnimation";
import {SKILL_CATEGORIES} from "../../data/resume";

export const SkillsSection = () => (
    <section id="skills" className="section shell" aria-labelledby="skills-title">
        <RevealAnimation>
            <div className="section-heading">
                <h2 id="skills-title">Capabilities<span className="accent-dot">.</span></h2>
                <p>The cross-functional range I bring to a small team, grouped around the work rather than a keyword cloud.</p>
            </div>
            <div className="capabilities-grid">
                {SKILL_CATEGORIES.map(category => (
                    <article className="capability-group" key={category.id}>
                        <h3>{category.name}</h3>
                        <ul>{category.skills.map(skill => <li key={skill}>{skill}</li>)}</ul>
                    </article>
                ))}
            </div>
        </RevealAnimation>
    </section>
);
